import SidebarOption from "./SidebarOption";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function OptionsSectioSidebar() {
    const[selectedOption, setSelectedOption] = useState('');
    const defaultOption = useLocation();

    const links = [
        { label: 'Día', path: "/visualization-day" },
        { label: 'Semana', path: "/visualization-week" },
        { label: 'Mes', path: "/visualization-month" },        
        { label: 'Projectos activos', path: "/visualization-active-projects" },        
    ];
    const handleOptionSelection = (to) => {
        setSelectedOption(to)
    }
    useEffect(() => {
        async function loadDefaultOption() {
            setSelectedOption(defaultOption.pathname);
            if (defaultOption.pathname === "/"){
                setSelectedOption("/example");
            }
            
        }
        loadDefaultOption();
    }, [])

    const renderLinks = links.map((link) => {
        return <SidebarOption
            key={link.label}
            to={link.path}
            className="mb-3"
            activeClassName="font-bold border-l-4 border-black pl-2"
            handleOptionSelection={handleOptionSelection}
            selected={selectedOption}
        >
            {link.label}
        </SidebarOption>
    })

    return (
        <div className="sticky top-0 overflow-auto scrollbar-hide flex flex-col items-start">
            <div className="text-black font-bold">Visualizaciones (Prox.)</div>
            <div className="grid grid-cols-1 ml-2">
                {renderLinks}
            </div>
        </div>
    )
};

export default OptionsSectioSidebar;